
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  "请输入您的国家":"Por favor ingrese su país",
  "借贷审核中":"Préstamo bajo revisión",
  "完成":"Completado",
  "可用贷款池":"Fondo de préstamos disponible",
  "直观易用的界面":"Interfaz intuitiva y fácil de usar",
    "访问 3,000 多个市场":"Accede a más de 3000 mercados",
    "实时更新和价格提醒":"Actualizaciones y alertas de precios en tiempo real",
    "各种技术指标、分析工具和高级图表":"Varios indicadores técnicos, herramientas de análisis y gráficos avanzados.",
    "先进的对冲策略和综合风险管理工具":"Estrategias de cobertura avanzadas y herramienta integrada de gestión de riesgos",
  "操作不熟练,试试模拟交易": "¿Principiante? Prueba trading simulado",
  "访问我们的帮助中心,获取交易指南": "Visita centro de ayuda para guías",
  "希望增进您的交易技巧？": "¿Mejorar habilidades de trading?",
  "每月提取金额": "Retiro mensual",
  "交易者": "Trader",
  "亿": "Cien millones",
  "万": "Diez mil",
  "3000多种品类供您选择": "+3000 productos disponibles",
  "24小时交易量":"Volumen de operaciones de 24 horas",
  "线上交易,请选择":"Para transacciones en línea, seleccione",
  "交易所":"intercambio",
  "3000多种品类,包括加密货币,贵金属,外汇, 原油等等":"Más de 3.000 categorías, incluidas criptomonedas, metales preciosos, divisas, petróleo crudo, etc.",
  "立即交易":"Opere ahora",
  "希望增进您的交易技巧":"Quiere mejorar sus habilidades comerciales",
  "访问我们的帮助中心,获取全面交易指南":"Visite nuestro Centro de ayuda para obtener guías comerciales completas",
  "去看看":"Ve y echa un vistazo",
  "操作不熟练,试试我们的模 拟交易功能":"Si no tiene experiencia en la operación, pruebe nuestra función de negociación simulada",
  "免费体验交易,让您尽快上手":"Intente operar gratis para poder comenzar lo antes posible",
  "马上体验":"Pruébalo ahora",
  "充币":"depositar monedas",
  "提币":"retirar monedas",
  "客服":"servicio al cliente",
  "更多":"Más",
  "热门品种":"Variedades populares",
  "卖出":"vender",
  "买入":"comprar",
  "了解我们的平台":"Conoce nuestra plataforma",
  "直观易用":"Intuitivo y fácil de usar",
  "的界面":"interfaz",
  "定期提供":"Proporcionado regularmente",
  "3,000多个市场":"Más de 3000 mercados",
  "的实时更新和 价格警报":"Actualizaciones en vivo y alertas de precios para",
  "各种技术指标":"Varios indicadores técnicos.",
  "分析工具和高级图表":"Herramientas de análisis y gráficos avanzados.",
  "套期保值模式和":"modelo de cobertura y",
  "风险管理工具":"herramientas de gestión de riesgos",
  "我们创建了技术领先且人性化的交易平台 ,为您提供贴心完善的交易体验":"Hemos creado una plataforma comercial tecnológicamente avanzada y fácil de usar para brindarle una experiencia comercial considerada y completa.",
  "实时新闻咨询":"Consulta de noticias en tiempo real.",
  "紧跟我们的新闻、产品和活动信息":"Manténgase al día con nuestras noticias, productos y eventos.",
  "阅读更多新闻":"Leer más noticias",
  "合作伙伴等最新新闻动态":"Últimas noticias sobre socios y más",
  "AI智能赚币":"Ganar dinero inteligentemente con IA",
  "出金":"Retirar fondos",
  "随存随取":"Deposita y retira en cualquier momento",
  "一键即刻取出,从不等待":"Sácalo inmediatamente con un clic, nunca esperes",
  "稳定":"Estabilizar",
  "最稳健的理财":"La gestión financiera más estable",
  "稳定收益,您的理财助手":"Ingresos estables, su asistente financiero",
  "执行速度":"Velocidad de ejecución",
  "极速执行":"Ejecución extremadamente rápida",
  "所有订单将以毫秒级别速度执行":"Todas las órdenes se ejecutarán a una velocidad de milisegundos.",
  "每天发放":"Distribuido todos los días",
  "当天产生收益":"Beneficio generado en el día.",
  "当天购买当天产生收益,24小时及时发放收益":"Los ingresos se generarán el mismo día de la compra y se distribuirán puntualmente las 24 horas del día.",
  "现在就开始":"empezar ahora",
  "交易全球金融市场":"Opere en los mercados financieros globales",
  "支持桌面端与移动端多种方式,您可随时 随地开展交易":"Admite múltiples métodos en terminales móviles y de escritorio, puede realizar transacciones en cualquier momento y en cualquier lugar",
  "谷歌下载":"descargar google",
  "下载":"descargar",
  "公司":"compañía",
  "关于我们":"sobre nosotros",
  "许可证监督":"Supervisión de licencia",
  "帮助中心":"Centro de ayuda",
  "政策":"política",
  "条款与条件":"Términos y condiciones",
  "隐私政策":"política de privacidad",
  "声明":"declaración",
  "法律信息":"información legal",
  "免责声明":"Descargo de responsabilidad",
  "风险警告":"Advertencia de riesgo",
  "关于广告":"Acerca de la publicidad",
  currency: {
    bb: 'Intercambio',
    bba: 'Cuenta de intercambio',
    hy: 'Contratos',
    jg: 'Comercio de opciones',
    jg1: 'Futuros',
    hya: 'Cuenta Contrato'
  },
  home:{
    user:'Elección común de usuarios',
    start:'Comienza a negociar',
    trading:'Productos comerciales',
    fee:'Tarifa mínima de manipulación',
    co:'Co',
    varieties:'Variedades comerciales',
    leading:'Liderando la innovación y exploración de web3',
    market:'Tendencias del mercado de productos comerciales.',
    explore:'Explora infinitas posibilidades',
    newcurrency:'¡La nueva función de suscripción de moneda está en línea!',
    alimited:'Hay nuevas monedas en línea, puedes comprar nuevas monedas que creas que tienen potencial aquí',
    get_start:'Comenzar',
    ai_coin:'El plan de obtención de monedas de IA está en marcha',
    ai_text:'Comience a ganar monedas con IA, ingresos estables, alta tasa de rendimiento, lo que le permite ganar monedas mientras está acostado.',
    loan:'La función de préstamo está en línea.',
    loan_text:'Cuando no tengas dinero, puedes solicitar un préstamo y se emitirá tan pronto como el mismo día.',
    mobile_pc:'Utilizado por enfermeras en PC móviles',
    pc_anytime:'Comience a operar en cualquier momento y en cualquier lugar:',
    pc_text:'Proporcionamos potentes herramientas de análisis de gráficos: más de cincuenta indicadores técnicos y herramientas de análisis de discos. El apalancamiento seguro, confiable, fácil de usar y las funciones de alto apalancamiento se han convertido en la plataforma estándar para la inversión en línea.',
    mobile_down:'haga clic para descargar',
    mobile_android:'Mercado Android',
    mobile_ios:'tienda Apple',
    open_text:'Puede solicitar una cuenta comercial real o probar una cuenta de demostración de forma gratuita por un tercio del costo.',
    open_account:'una cuenta',
    tocomplete:'completar',
    walletlogin:'Inicio de sesión de billetera'
  },
  index: {
    h24: 'Volumen 24H',
    header_title: ['Elija el comercio de activos digitales ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'Transacción completa de activos digitales blockchain de ventanilla única',
    header_msg: 'Seguro-estable-confiable',
    register_title: 'Registrar un ' + window.GLOBAL.LANG_TITLE.zh + ' la cuenta global comienza el viaje comercial',
    register_pl: 'Por favor, introduzca su correo electrónico o número de móvil',
    register: 'Regístrese',
    featureTitleWhy: 'Por qué elegirnos',
    featureTitle: 'Seguro · estable · confiable',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: 'Tecnología de billetera segura', msg: ['La tecnología de billetera fría y caliente es desarrollada por el mejor equipo de seguridad del mundo, y nunca ha habido un incidente de pérdida de monedas.',''] },
      { icon: icon2, title: 'Negocio rico en activos criptográficos', msg: ['Apoyar el comercio de derivados múltiples y al contado, etc., es su administrador personal en el mundo de los activos cifrados.',''] },
      { icon: icon3, title: 'Clientes distribuidos por todo el mundo', msg: ['Proporcione una gama completa de servicios de activos cifrados para usuarios en más de 130 países o regiones de todo el mundo.', ''] }
    ],
    bannerList: [
      {icon: banner01, title: "Comprometidos con proporcionar seguridad y estabilidad líderes en la industria", msg:["contratos inteligentes para proteger la seguridad de los activos de los inversores", "rendimiento comercial real", "garantía de servicio las 24 horas"]},
      {icon: banner02, title: "Quiero comprar y vender de inmediato mediante operaciones simples", msg:["pantalla de negociación simple", "reflejada inmediatamente en el saldo de su cuenta", "la mayoría de las criptomonedas se pueden comercializar"]},
      {icon: banner03, title: "Quiero obtener beneficios de forma activa mediante la negociación de contratos de liquidación", msg:["Abra una cuenta al mismo tiempo", "Inversión estratégica para una gran cantidad de futuros de negociación", "Puede negociar 24 horas al día, 365 días al año, incluso los fines de semana "]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparencia y apertura", msg:["Uso de las características de blockchain y contratos inteligentes, realización de transacciones en la cadena y uso de contratos inteligentes para garantizar la seguridad de los activos de los inversores", ""] },
      {icon: icon1_02, title: "Inversión inteligente", msg:["Con las estrategias diversificadas proporcionadas por los mejores expertos en comercio cuantitativo, puede elegir", ""]},
      {icon: icon1_03, title: "Calificación de riesgo", msg:["Diseñe productos de inversión diversificados basados ​​en los diferentes riesgos y preferencias de administración de activos de cada inversor, eliminando efectivamente los umbrales de inversión", ""]},
      {icon: icon1_04, title: "Productos diversificados", msg:["Proporcione varios tipos de necesidades de inversión de los usuarios y mecanismos de plataforma flexibles, y continúe produciendo servicios financieros innovadores que sean mejores que el mercado", ""]}
    ],
    featureTitle2: 'Transacción de terminal multiplataforma en cualquier momento y en cualquier lugar',
    featureMsg2: 'Cubriendo múltiples plataformas de iOS y Android, compatible con funciones de servicio completo',
    tab: ['Moneda convencional', 'Lista de aumento 24H'],
    thead: ['Par', 'Último precio', 'Precio más alto del día', 'Precio más bajo del día', 'Aumentar lista', 'Volumen 24H', 'operando'],
    more: 'Cargar más >',
    btn: 'Intercambio',
    dealsTitle: 'Servicio de comercio todo en uno',
    dealsTab:[
      { title: 'Intercambio', content: 'El intercambio tiene como objetivo el intercambio entre activos digitales, utilizando USDT como unidad de valoración para comprar otras monedas.'+window.GLOBAL.LANG_TITLE.zh+'Admite transacciones en tiempo real de activos digitales como Bitcoin, Ethereum y Litecoin.', src:'/static/image/deals-1.jpg', path: '' },
      { title: 'Contrato', content: 'Un derivado financiero de una moneda digital no solo admite la opción de comprar contratos de venta largos o cortos para obtener ingresos, sino que también es fácil de operar y nunca caduca.'+window.GLOBAL.LANG_TITLE.zh+'El contrato cuenta con un avanzado sistema de gestión de riesgos con apalancamiento de hasta 100 veces.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['Opcional', 'Contrato', 'Intercambio'],
    thead: ['Moneda', 'Último precio', 'Cambio 24H', 'Mínimo 24 horas', '24H más alto','Volumen 24H', 'operando'],
    nodata: 'Sin datos'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "Sobre nosotros",
        dd: [{ title: "Perfil de la empresa", id: 1 }, { title: "Centro de ayuda", type: 'help' }]
      },
      {
        dt: "Soporte al usuario",
        dd: [
          { title: "Acuerdo del Usuario", id: 3 },
          { title: "Política de privacidad", id: 5 }
        ]
      },
      {
        dt: "Contáctenos",
        icon: true
      }
    ],
    terms: "Términos y condiciones",
    serve: "Atender",
    product: "producto",
  },
  nav: {
    btn: ["iniciar sesión", "Regístrese", "gestión de activos","Descargar la aplicación"],
    nav: [
      // { title: "Inicio", path: "/index",name: 'index' },
      // { title: "Intercambio", path: "/deal",name: 'deal' },
      { title: "Mercado", path: "/market",name: 'market' },
      { title: "Comercio", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "Intercambio", path: "/deal", name: 'deal'},
      // { title: "Contrato", path: "/deal_c", name: 'deal_c' },
      // { title: "Criptomoneda", path: "/deal_jg", name: 'deal_jg' },
      // { title: "AI Ganar monedas", path: "/profit_index",name: 'profit_index' },
      { title: "Financiera", path: "/profit_index",name: 'profit_index' },
      // { title: "Actividades", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "Mis activos", path: "/asset" }],
    menus: [
      { icon: langzh, title: "Centro de usuarios", path: "/setting" },
      { icon: langen, title: "desconectar" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      // { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "descargar"
  },
  // 登录
  // login: {
  //   login: 'Ingresa, por favor',
  //   msg: 'Ingrese su cuenta registrada',
  //   list: ['móvil / correo electrónico', 'Contraseña', '¿Ha olvidado su contraseña?', 'iniciar sesión', 'Sin cuenta, regístrese ahora'],
  //   message: 'La cuenta o la contraseña no pueden estar vacías'
  // },
  register: {
    dl: ['Inscripción móvil', 'Inscripción por correo electrónico'],
    title: 'Registrar una cuenta',
    country: 'País de ciudadanía',
    country_info: 'La información de nacionalidad no se puede modificar después del registro, asegúrese de elegir la verdad',
    account: 'cuenta',
    code_text: 'Código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_unit: 's',
    code_no_data: 'se debe completar el código de verificación',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',
    pid_text: 'Código de invitación',
    pid_pl: 'Opcional',
    invitation_code_no_data: 'Se requiere el código de invitación',
    xy: 'Acuerdo del Usuario',
    xy_no_checked: 'Por favor seleccione acuerdo',
    agree: 'He leído y estoy de acuerdo',
    register_btn: 'Regístrese',
    bz: ['La información de nacionalidad no se puede modificar después del registro, asegúrese de elegir con sinceridad.', 'Es posible que el correo electrónico de verificación se califique erróneamente como correo no deseado; revíselo con atención.', 'Por favor guarde su' + window.GLOBAL.LANG_TITLE.zh + 'Número de cuenta y contraseña de inicio de sesión.', 'No utilice la misma contraseña de inicio de sesión que otros sitios web.'],
    account_no_data: 'La cuenta no puede estar vacía',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales'
  },
  // 设置密码
  bindmpwd: {
    title: 'configurar la clave',
    account: 'cuenta',
    code_text: 'Código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_unit: 's',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',
    code_no_data: 'se debe completar el código de verificación',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales',
    bindmpwd_btn: 'Confirmar',
    phone_no_data: 'El número de teléfono no puede estar en blanco',
    password_login_text: 'Introducir la contraseña de acceso',
    password_trade_text: 'Longitud de la contraseña 6 dígitos',
    password_again_tarde_text: 'Longitud de la contraseña 6 dígitos',
  },
  // 忘记密码
  forgetpwd: {
    title: ['cambiar la contraseña', 'Se te olvidó tu contraseña'],
    account: 'cuenta',
    code_text: 'Código de verificación',
    code_btn: 'Obtener CAPTCHA',
    code_unit: 's',
    password_text: 'Contraseña',
    password_again_text: 'Contraseña de nuevo',

    phone_no_data: 'El número de teléfono no puede estar en blanco',

    account_no_data: 'La cuenta no puede estar vacía',
    code_no_data: 'se debe completar el código de verificación',
    code_no_equality: 'Los códigos de verificación no son iguales',
    password_no_data: 'la contraseña no puede estar en blanco',
    password_no_equality: 'Las dos contraseñas no son iguales',
    forgetpwd_btn: 'Confirmar'
  },
  // 绑定手机号码
  bindphone: {
    title: 'Vincular número de teléfono móvil',
    phone_text: 'número de teléfono',
  },
  person: {
    more: 'Cargar más',
    no_more: 'Sin datos',
    index_center:"Centro de usuarios",
    index_menus: [
      { icon: zhsz, title: "Administración de cuentas", path: '/setting' },
      { icon: sfrz, title: "Autenticación KYC", path: '/sfyz' },
      { icon: sfrz, title: "Certificación junior", path: '/smauth' },
      { icon: sfrz, title: "Autenticación", path: '/seniorauth' },
      { icon: jtrz, title: "Autenticación de dirección", path: '/dzrz' },
      { icon: jtrz, title: "Comprar criptografía", path: '/kjmbSelect' },
      { icon: jtrz, title: "Puntaje de credito", path: '/credit' },
      { icon: jtrz, title: "Registros", path: '/deallog' },
      { icon: jtrz, title: "Registro de depósito", path: '/cbjl' },
      { icon: jtrz, title: "Registro de retiros", path: '/tbjl' },
    ],
    cbtb: 'Depósito y retirada',
    jymx: 'Detalles de la transacción',
    xyf: {
      'title': 'Puntaje de credito',
      'pgsj': 'Tiempo de evaluación'
    },
    smrz:{
       title:'KYC' ,
       sure_title:'Has sido autenticado',
       zj_type:'Tipos de documentos de indentidad válidos' ,
       zj_info:['1. La información de certificación no se puede modificar una vez verificada, por favor complete con la verdad','2. La información autenticada del nombre real no se puede volver a autenticar'],
       zj_name:'Nombre' ,
       zj_num:'Número del documento de indentidad' ,
       zj_btn:'ACEPTAR' ,
       zj_rebtn:'Vuelva a verificar' ,
       zj_sebtn:'Certificación senior' ,
       zj_type_array:[{name:'documento de indentidad de identidad',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "documento de indentidad de identidad"
        },
        {
            id: 2,
            name: "Pasaporte"
        },
        {
            id: 3,
            name: "Licencia de conducir"
        },
        {
            id: 4,
            name: "permiso de residencia"
        },
        {
            id: 5,
            name: "Otro tipo de documentos identificativos"
        }
       ],
       zj_data:{city:'La nacionalidad no puede estar vacía',type:'El tipo de credencial no puede estar vacío',name:'El nombre no puede estar vacío',zj_num:'El número de identificación no puede estar vacío'},
       zsxm: 'Nombre real',
       qsrzsxm: 'Por favor, introduzca su nombre real',
       zjlx: 'Tipos de documentos de indentidad válidos',
       qxzzjlx: 'Seleccione el tipo de documento de identidad',
       sfz: 'documento de indentidad de identidad',
       zjhm: 'Número del documento de indentidad',
       qsrzjhm: 'Por favor, introduzca el número del documento de indentidad',
       sczjz: 'Subir fotos del documento de identidad',
       zjzm: 'Subir foto del anverso del documento de identidad',
       zjfm: 'Subir foto del reverso del documento de identidad',
       qsczjzm: 'Subir foto del anverso del documento de identidad',
       qsczjfm: 'Subir foto del reverso del documento de identidad',
       scqmz: 'Subir documentos de identidad y firma personal',
       qscscqmz: 'Subir documentos de identidad y firma personal',
       zj: [
         {
           id: 1,
           title: 'documento de indentidad de identidad'
         },
         {
           id: 2,
           title: 'Pasaporte'
         },
         {
           id: 3,
           title: 'Otro tipo de documentos identificativos'
         },
       ],
       tj: 'Submáscara',
       shz: 'En revisión',
       shtg: 'Aprobado'
    },
    gjrz:{
      title:'Certificación senior',
      zj_info:['1. Se admiten imágenes de menos de 8MB y en formato JPG JPEG o PNG.','2. Las fotos del documento de identidad deben ser claras y no deben ser modificadas ni bloqueadas. El número del documento fotográfico personal y el nombre del titular del documento deben ser claramente visibles.','3. Las fotos deben tomarse sin ningún tipo de tocado y se recomienda no incluir el uso de maquillaje. Los rasgos faciales de la foto deben ser claros y reconocibles y sus brazos deben estar completamente expuestos.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'Configuraciones de seguridad',
      bind:[{bind_title:'Restablecer contraseña',bind_name:'Correo electrónico'},{bind_title:'Establezca la contraseña de retirada',bind_name:'Correo electrónico'}]
    },
    wdtg:{
      own_code:'Código de invitación',
      own_code_url:'Invitar a conectarse',
      own_push_title:'',
      own_push_content:['','',''],
      own_push_content_profit:['','','',''],
      own_push_content_num:['','','',''],
      own_push_profit_title: ['ID', 'ingresos', 'Marque','agregar tiempo'],
      own_push_num_title: ['ID', 'nombre', 'Teléfono','agregar tiempo'],
    },
    jyzt_td: ['hora', 'Detalles', 'Monto'],
    cbjl_td: ['hora', 'Moneda', 'Importe','estado'],
    sfrz_txt: ['KYC', 'Ha enviado la revisión, espere el resultado', 'Has superado la Certificateación senior', 'Subir foto del anverso del documento de identidad', 'Subir foto del reverso del documento de identidad', 'verificación','Error de autenticación, vuelva a autenticarse'],

    zhsz_txt: ['El nivel de seguridad de su cuenta: #', 'El nivel de seguridad de su cuenta: #，Mejorar más información para garantizar la seguridad de la cuenta'],
    zhsz_m: 'Fuerte',
    zhsz_n: 'débil',
    zhsz_p: 'No es seguro',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title: 'Contraseña de acceso ', value: 'Las cuentas de Internet corren el riesgo de ser robadas. Se recomienda que cambie su contraseña con regularidad para proteger la seguridad de su cuenta.',value2:'', btn: 'Modificación',bind_email:'Enlaza primero tu correo electrónico o teléfono móvil', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: 'Contraseña de transacción', value: 'configurar la clave', btn: 'Configurar', path: '/bindmpwd' }
    ],
    sksz_txt: ['Configuración de la colección', 'Guardar'],
    sksz_list: [
      { label: "nombre de usuario:", pl: "Por favor ingrese el nombre de usuario", key: "name" },
      { label: "Nombre de la cuenta bancaria:", pl: "Por favor, introduzca el nombre de la cuenta bancaria", key: "bank_name" },
      { label: "Cuenta bancaria:", pl: "Por favor, introduzca el número de cuenta", key: "bank_number" },
      { label: ":", pl: "", key: "alipay_account" },
      { label: "", pl: "", key: "weixin_nickname" },
      { label: "", pl: "", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'Inicio',
    prev: 'Pagina anterior',
    next: 'Siguiente página',
    last: 'última página',
    no_data: 'Sin datos',
  },
  asset: {
    title: 'Mis activos',
    zjhz: 'Transferencia de fondos',
    cb: 'Depósito',
    gz: 'Valoración del USDT',
    atnv: [],
    zh_title: 'Activos totales convertidos：',
    index_title: 'activos',
    address_title: 'Moneda',
    address_txt: ['por favor elige', 'Dirección de retirada de fondos', 'Por favor ingrese contenido', 'Marque', 'Lista de direcciones'],
    address_btn: ['añadir', 'Guardar', 'Borrar', 'Editar'],
    address_td: ['Moneda', 'Dirección de retirada de fondos', 'Marque', 'operando'],
    currency_td: ['Moneda', 'Disponible', 'Congelar', 'Cantidad convertida'],

    table_title: 'Los activos totales：',
    table_address_title: 'Dirección de retirada de fondos',
    table_td: ['Moneda', 'Disponible', 'Congelar', 'Cantidad convertida', 'operando'],
    table_btn: ['Depósito', 'Retirada de fondos', 'Registro', 'Transferir'],

    money_text: ['Dirección de retirada de fondos', 'por favor elige', 'Importe', 'Disponible：', 'Tarifa',
      'Importe a retirar', 'Contraseña de transacción','etiqueta(Memo)','Mínimo'],
    money_btn: 'Retirada de fondos',
    xzbz: 'Selección de moneda',
    money_msg: ['recordatorio ',' ', '','','',''],

    recharge_title: 'Dirección de depósito',
    recharge_btn: ['Copiar', 'Código QR', 'Depósito'],
    recharge_text: ['Importe', 'recordatorio', 'Por favor, no ingrese ningún activo que no sea en moneda local en la dirección mencionada o los activos no se recuperarán', 'Los depósitos del USDT solo admiten el método de envío simple. Los depósitos que utilicen otros métodos (enviar todos) no se pueden contabilizar temporalmente. Por favor, comprenda.', 'certificado', 'Descripción del bono(Opcional)','Nombre de la cadena'],

    record_title: 'Registros financieros',
    record_td: ['Importe', 'Registro', 'Hora'],

    transfer_title: 'Transferir',
    transfer_btn: ['Todos', 'Transferir'],
    transfer_text: ['de', 'a', 'Ingrese el monto de la transferencia', 'Disponible：'],
    "bq": "Etiqueta (Memo)",
    "qsrbq": "Por favor, introduzca la etiqueta",
    "yhktx": "Retiro con tarjeta bancaria",
    "yhmc": "Nombre del banco",
    "qsryhmc": "Por favor, introduzca el nombre del banco",
    "yhzh": "Cuenta bancaria",
    "qsryhzh": "Por favor, introduzca la cuenta bancaria",
    "gjhkdm": "Código SWIFT",
    "qsrgjhkdm": "Introduzca el código SWIFT",
    "yhdz": "Dirección del banco",
    "qsryhdz": "Ingrese la dirección del banco",
    "skrxm": "Nombre del beneficiario",
    "qsrskrxm": "Ingrese el nombre del beneficiario",
    "skrdh": "Teléfono del beneficiario",
    "qsrskrdh": "Por favor, introduzca el teléfono del beneficiario",
    "skrdz": "Dirección del beneficiario",
    "qsrskrdz": "Por favor, introduzca la dirección del beneficiario"
  },
  text: {
    btn: 'espalda',
    login: 'Por favor, registrese'
  },
  deal: {
    chooseType: 'Tipo de comisión',
    choose: 'por favor elige',
    balance: 'Saldo：',
    account: ['Cuenta', 'Disponible', '/Congelar', 'Transferir'],
    dir: ['Comprar', 'Vender'],
    dir2: ['Disponible', 'Mercado'],
    cs: 'Favoritos',
    sxf: 'Tipo de comisión',
    jye: 'Venta',
    sc_list: ['Precio de mercado', 'par', 'Incrementar'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['Moneda', 'Último precio', 'Incrementar'],
    k_line_txt: ['≈', '', 'Incrementar', 'Precio más alto', 'El precio más bajo', 'Volumen 24H'],
    tabListLTitle: ["Orden actual", "Historial de ordenes "],
    tabListLEntrust: ["Comprar", "Vender"],
    tabListRTitle: ["Límite de precio", "Precio de mercado"],
    table_btn: ['Retirar fondos'],
    index_td_l: ['Hora', 'Socios comerciales', 'Importe', 'Precio', 'operando'],
    index_td_r: ['Último precio', 'Dirección', 'Precio', 'Importe'],
    index_td_r2: ['Última transacción', 'Hora', 'Precio', 'Volumen de comercio'],
    table_txt: ['terminado', 'Retirado'],

    db_1_txt: ['Disponible', 'precio de compra', 'Precio de venta', 'Aceptacion', 'Vender volumen', 'Venta', 'Compra al mejor precio del mercado', 'Vende al mejor precio del mercado', 'Comprar lote', 'Vender lote'],
    db_2_txt: ['Precio', 'Aprovechar', 'por favor elige', 'Lotes de negociación', 'Lote =', 'lotes', 'Valor de mercado del contrato', 'Bono', 'Compra al mejor precio del mercado', 'Vende al mejor precio del mercado'],
    pathList: ['Registro de contrato', 'Registro de la transacción'],
    db_btn: ['Comprar(Largo)', 'Vender(Corto)'],
    tabListLTitle2: ['Orden actual'],

    lt_btn: ['Liquidar con un clic', 'Obtenga ganancias y deje de perder', 'Cerrar posición', 'Submáscara', 'espalda'],
    lt_txt: ['Tasa de riesgo：', 'Beneficio total：'],
    lt_td: ['Tipos de','Aprovechar', 'Precio de la posición', 'Precio actual', 'Bono', 'Precio de toma de beneficios', 'Precio stop-loss', 'Hora de apertura', 'Lotes de negociación', 'Ganancia y perdida', 'operando'],
    lt_dl: ['Obtenga ganancias y deje de perder', 'Precio de toma de beneficios', 'Precio stop-loss'],

    lt_0_btn: ['Retirar fondos'],
    lt_0_td: ['Detalles de contacto', 'Moneda', 'Importe', 'Precio actual', 'Tarifa', 'operando'],

    lt_1_btn: ['Cerrar posición'],
    lt_1_txt: ['Cerrando posición'],
    lt_1_td: ['Tipos de', 'Precio de la posición', 'Precio actual', 'Bono', 'Precio de toma de beneficios', 'Precio stop-loss', 'Hora de apertura', 'Tarifa', 'Ganancia y perdida', 'operando'],
    node_data: 'Sin datos',

    lt_3_txt: ['Posición cerrada', 'Liquidación'],
    lt_3_td: ['Tipos de', 'Lotes de negociación', 'Precio de la posición', 'Precio de cierre', 'Precio de toma de beneficios', 'Precio stop-loss', 'Bono', 'Margen disponible', 'Hora de apertura', 'Hora de cierre', 'Tarifa',
      'Ganancia y perdida', 'operando'],

    lt_4_txt: ['Retirado'],
    cm: ['Hora de salida', 'Número de edición', 'Circulación total', 'Precio total', 'Sitio web oficial','Papel blanco','Información'],
    qsrsl: 'Introducir el importe',
    qsrss: 'Entrar en Lotes de Negociación',
  },
  notice:{
      notice_title:'Centro de anuncios',
  },
  bzhl:{
    title: 'Inversión en IA',
    title1: 'Cuantificación de IA',
    ttzbt: 'Sigue ganando dinero todos los días',
    wdtg: 'Pedir deposito en garantía ',
    zztgdzj: 'Fondos en custodia',
    yjjrsy: 'Ingresos del día',
    ljsy: 'Ingresos acumulados',
    tgzdd: 'Pedido en custodia',
    tgdd: 'Pedido en custodia',
    t1: 'Gestión financiera estable y de bajo riesgo, reembolsable en cualquier momento si es necesario',
    t2: 'Su asistente de administración de dinero gratuito',
    cljxcp: 'Ciclo del producto',
    dbxe: 'Límite único',
    rsyl: 'Tasa de rendimiento diaria(%)',
    rsyl2: 'Tasa de rendimiento diaria：',
    zq: 'Ciclo',
    qmr: 'Comprar',
    ckgd: 'más',
    cpgk: 'Descripción del producto',
    pxsj: 'Tiempo de dividendo',
    tgzj: 'Capital en custodia',
    tqsh: 'Retorno anticipado',
    cpld: 'Destacados del producto',
    cpgz: 'regla',
    cont: 'La ganancia de USDT es administrada por el equipo profesional de la plataforma alojando USDT en la plataforma. Los participantes pueden obtener la participación en los ingresos de la plataforma durante el período de custodia del fondo, al que se puede acceder en cualquier momento, lo cual es seguro y conveniente.',
    zj: '100%fondos',
    aqbz: 'Seguridad',
    jjrsy: 'Ingresos de vacaciones',
    bjd: 'Ininterrumpido',
    cgcrh: 'Después de un depósito exitoso',
    dtqx: 'Calcule el interés del día',
    ljzr: 'Transfiera ahora',
    xqglgj: 'Herramientas gratuitas de administración de dinero',
    ddh: 'Número de pedido',
    tgje: 'Importe de la custodia',
    tgsj: 'tiempo de la custodia',
    yhl: 'Beneficios obtenidos/días restantes',
    xdsj: 'Tiempo de pedido',
    zt: 'estado',
    fh: 'espalda',
    qrnhsy: 'Ingreso anualizado de siete días',
    ygy: '1 mes',
    bn: 'Medio año',
    yn: '1 año',
    yuan: '$',
    tzfx: 'riesgo de inversión',
    shsc: 'Tiempo de redención',
    di: 'bajo',
    yggzr: 'Un día laborable',
    msgsxf: 'Cuota de suscripción gratuita',
    mr: 'Diario',
    dqfh: 'Retorno a vencimiento',
    ljgm: 'Comprar ahora',
    tgz: 'Pedido en custodia',
    sh: 'Retorno anticipado',
    ywc: 'terminado',
    ysh: 'Recuperar',
    all: 'Todos',
    "xzbzts": "Sencillo y seguro. Los dividendos se pueden seleccionar en varias monedas",
    "qtbz": "Otras monedas"
  },
  pay:{
    qsrjymm: 'Longitud de la contraseña 6 dígitos',
    tbmmts: 'Vaya al centro de usuarios para configurar la contraseña de la transacción',
  },
  tips:{
    qxztbdz: 'Por favor, introduzca la dirección de retiro',
    qsrtbsl: 'Introducir el importe'
  },
  statusText: ['falla','Procesando','éxito'],
  dzrz: {
    title: 'Autenticación de dirección',
    sdddz: 'Dirección de la factura de servicios públicos',
    zdtpsc: 'Carga de imagen de factura',
    qsrsdddz: 'Debe completar la información de la dirección y enviar la factura de servicios públicos o la factura de dirección de banda ancha',
    qsczdtp: 'Sube una foto de la factura',
    status: ['En revisión','Aprobado'],
    qd: 'ACEPTAR',
  },
  jgcc: {
    wtgd: 'Orden pendiente',
    cj: 'Transacción',
    jj: 'Información',
    zc: 'Actualidad',
    lszc: 'Historia',
    qblx: 'Todos los tipos',
    xj: 'Precio actual',
    sj: 'Hora',
    fx: 'Dirección',
    jg: 'Precio',
    sl: 'Importe',
    jgsj: 'Hora de entrega',
    gmj: 'Precio de compra',
    jsj: 'Precio de liquidación',
    yk: 'Ganancia y perdida',
    xq: 'Detalles',
    "mz": "Alcista",
    "md": "Bajista",
    dqye: 'Saldo actual',
    gb: 'Cerrar',
    jxxd: 'Continuar con el pedido',
    qrxd: 'Confirmar',
    ddqr: 'Confirmación de pedido',
    sxf: 'Tarifa',
    kyye: 'Equilibrio',
    jypz: 'Par',
    jyfx: 'Dirección',
    tzje: 'Precio de la inversión',
    tzjeTips: 'Precio más bajo 0',
    dqsj: 'Hora de caducidad',
    jssj: 'Hora de entrega',
    gmsj: 'Tiempo de compra',
    sy: 'ingresos',
    zxje: 'Monto minimo ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: 'Cantidad máxima ',
    qsrje: 'Ingrese el importe',
    zxtzje: 'Mínimo ',
    yebz: 'Saldo insuficiente',
    xq: 'Detalles',
    ddz: 'Esperando',
    jgjl: 'Registro de entrega',
    bz: 'Moneda',
    cz: 'operando'
  },
  kjmb: {
    title: 'Comprar criptografía',
    fzcg: 'Copiar con éxito',
    ljmb: 'Comprar criptografía',
    lxkf: 'Contactar Servicio al Cliente'
  },
  news: {
    title: 'Mis mensajes',
    "gg": "Notificación",
    ckxq: 'Ver detalles',
  },
  statusTabs:['Orden pendiente', 'En transacción','Posición cerrada', 'Retirado'],
  "chongzhi":{
    "zy": "Importante",
    "cbxx": "Información de depósito de tokens",
    "qsrsl": "Ingrese el monto del depósito",
    "tips2": "1. Compatibilidad de billetera / plataforma: es decir, la red es compatible, si la plataforma de destino no es compatible con su red de retiro, los activos no se pueden recuperar.",
    "tips3": "2. Su red de recarga y la plataforma de destino son la misma, si elige la dirección de destino es la red Ethereum, pero la recarga elige la cadena inteligente TRC20, es posible que no pueda recuperar sus activos digitales.",
    "tips4": "3. Asegúrese de que su dirección y la cantidad sean correctas antes de recargar.",
    "tips5": "Recordatorio: debido al anonimato y la privacidad de la red de bloques, una vez que ingrese la información incorrecta, perderá los activos correspondientes. Comprueba cuidadosamente tu dirección de recarga y la cantidad.",
    "tips2_1": "• No cargue ningún activo en moneda que no sea local a la dirección anterior, de lo contrario, los activos no se podrán recuperar.",
    "tips2_2": "• La moneda digital no se puede entregar a tiempo. La hora de llegada real depende de la velocidad de confirmación de la cadena de bloques.",
    "tips2_3": "• Su dirección de recarga no cambiará con frecuencia, puede recargar; si hay algún cambio, haremos todo lo posible para notificarle a través de un anuncio en el sitio web o por correo electrónico.",
  },
  "tibi": {
    "tbxx": "Información de retiro",
    "qsrbq": "Introduzca una etiqueta",
    "tbTips1": "• Para garantizar la seguridad de los fondos, cuando la política de seguridad de su cuenta cambie, la contraseña cambie, revisaremos manualmente el retiro, espere pacientemente a que el personal se comunique con usted por teléfono o correo electrónico.",
    "tbTips2": "• Asegúrese de que su computadora y navegador sean seguros para evitar que la información sea alterada o filtrada.",
    "tbTips3": "• El activo digital que mencionaste es un activo multicadena de una moneda. Independientemente de la cadena desde la que elijas subir, significa que la cantidad total de activos digitales que se muestran en la página de retiro de tu propiedad se reducirá por la cantidad correspondiente recaudada. ",
  },
  "gjlb": "Lista de países",
  "qxzgjlb": "Por favor seleccione País / Región",
  "mbwt":{
    "title": "Cuestiones de seguridad",
    "mbwt": "Cuestiones de seguridad",
    "problem":[
      {
        "id": 1,
        "title": "¿Quién es tu mejor amigo(amiga)?"
      },
      {
        "id": 2,
        "title": "¿Quien es tu idolo?"
      },
      {
        "id": 3,
        "title": "¿Dónde está tu lugar más anhelado?"
      }
    ],
    "qtxda": "Por favor, responda a la pregunta",
    "qsrxmm": "Ingrese una nueva contraseña",
    "qqrmm": "Por favor, confirme su contraseña",
    "sydqmmcz": "Restablecer con la contraseña actual",
    "zhmm": "Problemas de seguridad Recuperar contraseña",
    "ysz": "Configurar",
    "tg": "Ignorar",
    "tj": "Enviar",
    "zyts": "Importante:",
    "zytsCont": "No revele la respuesta secreta y el código de verificación, y tenga en cuenta el problema de seguridad, que lo ayudará a recuperar su contraseña."
  },
  "zc":{
    "zclb": "Lista de activos",
    "zczh": "Conversión de activos",
    "yczc": "Ocultar activos que no tiene"
  },
  "indexNew":{
    "t1": "Líder mundial",
    "t2": "Plataforma de servicios de activos digitales",
    "t3": "Transacción completa de activos digitales blockchain de ventanilla única",
    "t4": "Número de móvil / correo electrónico",
    "t5": "Regístrese ahora",
    "t6": "Dar la bienvenida a clientes de todo el mundo a través de MFTG",
    "t7": "Descubra e inicie su viaje de cifrado"
  },
  "newReg":{
    "dl": ['Email','Móvil'],
    "cjzh": "Crear una cuenta",
    "sysjhzyx": "Número de móvil / registro de correo electrónico",
    "yhxy": "&lt;Acuerdo de usuario&gt;",
    "yhxy2": "He leído y acepto el &lt;Acuerdo de usuario&gt;",
    "yxgz": "Por favor introduzca una dirección de correo electrónico válida",
    "dhgz": "El número de teléfono móvil es incorrecto."
  },
  "indexNew2": {
    "t1": "Opere en nuestro pedido",
    "t2": "Usar Bitbank",
    "t3": "Bitbank es un intercambio ingeniosamente diseñado de bitcoins y activos cifrados. Es muy simple, conveniente, seguro y poderoso. Admite transacciones en múltiples plataformas web y de teléfonos inteligentes. Los datos y gráficos de las transacciones se actualizan en tiempo real. Completo El análisis de precios de mercado proporciona más de 60 herramientas de análisis técnico. Empiece a operar ",
    "ksjy": "Empiece a operar",
    "ly": "5 razones para elegir Bitbank",
    "item1_t1": "Volumen de operaciones líder",
    "item1_t2": "N ° 1 * Volumen de negociación de activos criptográficos",
    "item1_t3": "Negociación cómoda (experiencia comercial agradable) con alta liquidez. Enumere 12 tipos de activos criptográficos.",
    "item2_t1": "Evaluación de terceros alta",
    "item2_t2": "Entorno comercial seguro",
    "item2_t3": "Use la billetera fría sin conexión. Use Multisig para mantener alejados a los piratas informáticos. Proteja sus activos con alta tecnología",
    "item3_t1": "Aplicación confiable y fácil de usar",
    "item3_t2": "Fácil de usar y aplicación sencilla",
    "item3_t3": "Una aplicación confiable con funciones ricas. Puede mantener oportunidades comerciales fuera de la transacción.",
    "item4_t1": "Abierto todo el día",
    "item4_t2": "Puede depositar oro",
    "item4_t3": "Soporte de depósito las 24 horas, incluidos festivos",
    "item5_t1": "Smartphone y PC",
    "item5_t2": "Diseño humanizado",
    "item5_t3": "Incluso si usa un teléfono inteligente, puede realizar transacciones simples y calificadas sin dudarlo",
    "aqkk": "Seguro y confiable",
    "aqkk2": "Transacción Bitcoin de Bitbank",
    "cjzh": "Crear una cuenta",
  },
  "xbsg":{
    "title": "Nueva zona de monedas",
    "wdsg": "Detalles",
    "scts": "Días de encierro: ",
    "sy": "restante",
    "ljsg": "Suscríbase ahora",
    "ysk": "Vendido",
    "xzjdy": "Suscríbase ahora",
    "dy": "Suscribir",
    "fxjg": "precio de emisión",
    "fxl": "Circulación",
    "ssrq": "Fecha de cotización",
    "yxqx": "Período de validez",
    "qsrsl": "Por favor ingrese la cantidad",
    "syl": "restante",
    "sgrq": "suscribir",
    "sgsl": "Monto",
    "bz": "Moneda",
    "yebz": "Saldo de USDT insuficiente",
    "tgsl": "Cantidad de pases",
    "shz": "bajo revisión",
    "wtg": "No pasó",
    "ytg": "aprobado"
  },
  "wydb":{
    "title": "Pedir prestado",
    "db": "Pedir prestado",
    "dbz": "Pedir prestado",
    "jl": "registros de préstamos",
    "jdzq": "Período (días)",
    "qhk": "Volver a pagar",
    "ljdb": "Acumulativo (usd)",
    "dhkbs" :"Reembolso",
    "jkje": "cantidad (usdt)",
    "qsrje": "Por favor ingrese la cantidad",
    "rll": "Tasa de interés diaria",
    "hkfs": "Reembolso",
    "dqych": "Caducado",
    "lx": "Interesar",
    "fkjg": "Prestador",
    "tpsc": "Préstamo de crédito (carga de imagen)",
    "fwxx": "Información de vivienda",
    "srzm": "Comprobante de ingresos (relación laboral)",
    "yhmx": "Extracto de cuenta",
    "zjz": "foto de identificación",
    "yd": "He leído y estoy de acuerdo",
    "xy": "Solicitar un acuerdo de préstamo",
    "sqdb": "Solicitar un préstamo",
    "gb": "cierre",
    "qd": "OK",
    "ts": "Por favor marque Solicitar un acuerdo de préstamo",
    "dbjl": "registro",
    "hkhth": "Código de orden",
    "wsh": "sin revisar",
    "yfk": "Préstamo",
    "sqrq": "tiempo de aplicación",
    "zq": "ciclo",
    "dbsl": "Monto",
    "zhke": "Pago total",
    "yhke":"Monto pagado",
    "yhkxq": "Detalles de reembolso",
    "bqyhk": "Reembolsable en el período actual(USDT)",
    "hktips": "Asegúrese de que el saldo sea suficiente, si el saldo es insuficiente, recargue primero y luego pague",
    "bj": "Principal",
    "jie": "Pedir prestado",
    "ljhk": "pagar inmediatamente",
    "qcz": "Depositar",
    "yebzqxcz": "Saldo insuficiente, recargue primero y luego pague",
    "znj": "cargo del pago atrasado",
    "yqts": "Dias atrasados"
  },
  "hkxq":{
    "dd":"Pedido",
    "fzhkdz":"Copia la dirección de pago",
    "hkxq": "Detalles de reembolso",
    "zlx": "interés total",
    "zhk": "reembolsos totales",
    "hkjg": "agencia de pago",
    "qschkpz": "Cargue el certificado de reembolso",
    "hkpz": "certificado de reembolso"
  },
  "bbjyNew":{
    "jylx": "Tipos de",
    "jyze": "Cantidad"
  },
  "bind":{
    "title": "Verificacion de Email",
    "ybd": "Unido",
    "wbd": "Sin consolidar",
    "ts": "Para proteger su cuenta, se recomienda vincular una dirección de correo electrónico",
    "qsryxdz": "Por favor, introduzca su dirección de correo electrónico"
  },
  "tipsNew": {
    "yjj": "rechazado",
    "shz": "redención"
  },
  "newIndex2":{
    "zxhy": "Cotizaciones más recientes",
    "jypt": "Plataforma comercial",
    "ssyc": "Reducir Ocultar",
    "hwzc": "¿Aún no estás registrado?",
    "ljzc": "¡Regístrate ahora y descubre toneladas de oportunidades!",
    "yyzh": "¿Ya tienes una cuenta?",
    "hjbj": "Inicia sesión si tienes una cuenta, ¡mucho tiempo sin verte!",
    "lmdh": "Navegación por columnas",
    "ghdjy": "Mejor trato, mejor vida",
    "ghdjy02": "El centro de intercambio de criptomonedas más innovador del mundo está aquí, donde puedes comprar, intercambiar y ganar criptomonedas con cientos de criptomonedas al alcance de tu mano.",
    "indexCont01": "Siempre a tu lado",
    "indexCont02": "Opere en nuestros mercados al contado y de margen con opciones de financiación avanzadas, ejecución ultrarrápida y gran liquidez.",
    "indexCont03": "Potente API",
    "indexCont04": "Gestione sus posiciones sin esfuerzo con nuestra API intuitiva, nuestra plataforma de operaciones y opciones de órdenes avanzadas.",
    "indexCont05": "Activos digitales de alta calidad",
    "indexCont06": "9 años 0 accidentes",
    "indexCont07": "Control de riesgos de seguridad superior",
    "indexCont08": "Apalancamiento hasta 25 veces",
    "indexCont09": "Opere con CFD de Bitcoin con un apalancamiento de hasta 25x.",
    "indexCont010": "Reserva de seguridad",
    "indexCont011": "Liquidez Profunda",
    "indexCont012": "Nuestra avanzada tecnología patentada de libro de pedidos de múltiples mercados mejora la liquidez, ajusta los diferenciales y reduce el deslizamiento.",
    "indexCont013": "Preferencia del usuario",
    "indexCont014": "País cubierto",
    "indexCont015": "Nuestras fortalezas",
    "indexCont016": "Opere en nuestros mercados al contado y de margen con opciones de financiación avanzadas, ejecución ultrarrápida y gran liquidez.",
    "indexCont017": "Almacenamiento Seguro",
    "indexCont018": "Usamos una combinación de billeteras frías y tecnología de computación multipartita (MPC) para administrar los activos digitales.",
    "indexCont019": "La seguridad ante todo",
    "indexCont020": "Usamos la última tecnología para mantener sus fondos seguros y anticiparnos a errores e intentos de explotación.",
    "indexCont021": "Retiro rápido",
    "indexCont022": "Usando el cómputo de múltiples partes, podemos proporcionar retiros rápidos las 24 horas del día, los 7 días de la semana, manteniendo nuestros estrictos estándares de seguridad.",
    "indexCont023": "Comprar, vender criptomonedas",
    "indexCont024": "Únase a la plataforma comercial más completa y segura del mundo",
    "indexCont025": "Compra y vende Bitcoin, Ethereum, XRP y muchas otras criptomonedas usando fiat o criptomonedas.",
    "yqwj": "10 millones+",
    "dlzc": "Iniciar sesión para registrarse",
    "yzm": "Código de verificación",
    "qrmm": "Confirmar contraseña"
  },
  "langNew2":{
    "flzq": "Centro de recompensas",
    "qdjl": "Iniciar sesión recompensa",
    "mrqdjl": "Recompensa de inicio de sesión diario",
    "qd": "Iniciar sesión",
    "yqd": "Registrado",
    "hdgz": "Reglas del evento",
    "qdjl2": "registro de entrada",
    "qdcg": "Iniciar sesión con éxito",
    "yhd": "Adquirido",
    "lq": "Recibir",
    "dyt": "Día 1",
    "det": "Día 2",
    "dst": "Día 3",
    "dsit": "Día 4",
    "dwt": "Día 5",
    "dlt": "Día 6",
    "dqt": "Día 7",
    "jxz": "en progreso",
    "cjxnzh": "Crear cuenta virtual",
    "sy":"Pagina de inicio",
    "sc":"Mercado",
    "sclb":"Lista de mercado",
    "jy":"Comercio",
    "zh":"Cuenta",
    "db":"Préstamos",
    "zchm":"Número de registro",
    "cp":"Producto",
    "tzjd":"Préstamos de inversión",
    "zxzc":"Soporte en línea",
    "xd":"Orden",
    "zzjptgmnr":"Invierta en su futuro. Haga crecer su cartera en un sistema financiero justo y abierto.",
    "yy":"Aplicación",
    "pqnr":"Banca móvil que rompe con las reglas tradicionales y te proporciona herramientas precisas de gestión financiera.",
    "jiami":"Cripto",
    "tgnr":"Al realizar depósitos utilizando criptomonedas, obtienes una capa adicional de seguridad y garantizas un procesamiento rápido de las transacciones.",
    "jyl":"Volumen de operaciones las 24 horas",
    "ssjmhb":"Listado de criptomonedas",
    "zchy":"Usuarios Registrados",
    "djxz":"Haga clic para descargar",
    "azsc":"Mercado de Android",
    "pgsd":"Tienda Apple",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "Criptomoneda",
  //   "gjs": "Metal",
  //   "yy": "Crudo",
  //   "jy": "Comercio",
  //   "jmhb": "Criptomoneda",
  //   "yxhy": "Contrato perpetuo",
  //   "gdjy": "orden pendiente",
  //   "khh": "Abrir cuenta bancaria",
  //   "qsrkhh": "Por favor ingrese al banco",
  //   "yhkh": "Cuenta bancaria",
  //   "qsryhkh": "Por favor, introduzca el número de cuenta bancaria",
  //  },
   "login":{
     login: 'Ingresa, por favor',
     msg: 'Ingrese su cuenta registrada',
     list: ['móvil / correo electrónico', 'Contraseña', '¿Ha olvidado su contraseña?', 'iniciar sesión', 'Sin cuenta, regístrese ahora'],
     message: 'La cuenta o la contraseña no pueden estar vacías',
     "cdlks":"¡Comencemos con iniciar sesión!",
     "zh":"Cuenta",
     "qsrzh":"Ingrese su nombre de usuario",
     "mm":"Contraseña",
     "qsrmm":"Introducir la contraseña",
     "dl":"Iniciar sesión",
     "wjmm":"Has olvidado tu contraseña",
     "qbdl":"Iniciar sesión por billetera",
     "myzh":"¿No tengo una cuenta?",
     "zc":"Inscribirse",
     "yzm":"Código de verificación",
     "qsryzm":"Ingrese el código de verificación",
     "hqyzm":"Código enviado",
     "qrmm":"confirmar Contraseña",
     "qsrqrmm":"confirmar Contraseña",
     "lcmmbyz":"Las dos entradas de contraseña son inconsistentes",
     "mmts":"Longitud de la contraseña de 6 a 12 caracteres",
     "sjtx":"Error de formato del número de teléfono",
     "yxts":"Error de formato de correo electrónico",
     "qr":"DE ACUERDO",
     "sjzc":"Móvil",
     "sjh":"Número de teléfono",
     "qsrsjh":"Ingresa número telefónico",
     "yqm":"Código de invitación (opcional)",
     "qsryqm":"Introduce el código de invitación",
     "yxzc":"Correo electrónico",
     "wyydbzx":"Aceptar",
     "yhxy":"<Acuerdo de servicios de usuario>",
     "yhxy2":"Acuerdo de servicios de usuario",
     "ysyx":"<Acuerdo de protección de privacidad>",
     "yx":"Correo electrónico",
     "qsryx":"Ingrese correo electrónico",
     "yxgsbzc":"Email inválido",
     "cjmnzhcg":"Cuenta demo creada exitosamente",
     "tcmnzh":"Salir de la cuenta demo",
     "qbdlts":"Utilice la billetera DAPP Iniciar sesión",
   },
  //  "index":{
  //    "xgnysx":"¡Nuevas funciones están en línea!",
  //    "hyld":"Bienvenido a nuestra galardonada plataforma de comercio financiero y explore el futuro mundo financiero con inversores globales",
  //    "symncz":"Utilice una cuenta demo",
  //    "zdjyfy":"Tarifas de transacción mínimas <0,3%",
  //    "jysyzc":"Opere con todos sus activos en un solo lugar",
  //    "hbsp":"Forex, Criptomonedas, Acciones, Índices, Materias Primas",
  //    "ksjy":"Comenzar",
  //    "jdewd":"Sencillo y estable",
  //    "aizb":"Comercio de IA dorado",
  //    "srjh":"Crea tu plan de ingresos en un clic",
  //    "kssy":"Empieza a usar",
  //    "dlyhggdje":"Tasas de interés bajas y cantidades más altas",
  //    "jmhbdk":"Préstamos en criptomonedas",
  //    "zmyrhdyp":"Tomar prestado un lugar de criptomonedas sin ninguna garantía",
  //    "gs":"Compañía",
  //    "gywm":"Sobre nosotros",
  //    "xkzjd":"Supervisión de licencia",
  //    "bzzx":"Centro de ayuda",
  //    "zhengce":"Política",
  //    "tkytj":"Términos y condiciones",
  //    "yszc":"política de privacidad",
  //    "sm":"Declaración",
  //    "flxx":"Información legal",
  //    "mzsm":"Descargo de responsabilidad",
  //    "fxjg":"Advertencia de riesgo",
  //    "gygg":"Acerca de la publicidad",
  //    "gg":"Anuncio",
  //  },
   "hq":{
     "wh":"Forex",
     "szhb":"Cripto",
     "gp":"Existencias",
     "zs":"Índice",
     "eft":"ETF",
     "mc":"Nombre",
     "xs":"24h%",
     "tb":"Cuadro",
     "jg":"Precio",
   },
   "user":{
     "wdzh":"Mi cuenta",
     "zh":"Cuenta: ",
     "dk":"Préstamo: ",
     "sydbzj":"Margen utilizado: ",
     "yqll":"Ganancia esperada: ",
     "qtgn":"Otras funciones",
     "cz":"Depósito",
     "tx":"Retirar",
     "dh":"Intercambio",
     "zhyz":"Certificación KYC",
     "zhjl":"Historial de cuenta",
     "yqhy":"Invitar a amigos",
     "flzq":"Zona de bienestar",
     "ggmm":"Cambiar la contraseña",
     "sz":"Ajustes",
     "cjwtjd":"Preguntas más frecuentes",
     "fzdz":"Copiar dirección",
     "sl":"Cantidad...",
     "qsrsl":"Introduce la cantidad",
     "dd":"Obtener (USDT): ",
     "sczm":"Subir bono",
     "qsczm":"Por favor cargue el comprobante",
     "tj":"Entregar",
     "czjl":"Registro de depósito",
     "ddh":"No.",
     "wsh":"No revisado",
     "ywc":"Terminado",
     "bz":"Nombre: ",
     "sl2":"Cantidad: ",
     "sj":"Tiempo: ",
     "srsl":"Introduce la cantidad...",
     "dd2":"Conseguir: ",
     "qskgzflhd":"Por favor, preste siempre atención a las actividades de bienestar, las publicaremos de vez en cuando.",
     "hdlb":"Lista de eventos",
     "ckxq":"Ver detalles",
     "wdjl":"Mi recompensa",
     "yiji":"Nivel 1",
     "erji":"Nivel 2",
     "sanji":"Nivel 3",
     "je":"Cantidad",
     "sj2":"Tiempo",
     "yyxz":"Idioma",
     "tcdl":"desconectar",
     "je2":"Monto (USD)...",
     "qsrje":"Introduce la cantidad",
     "jsdz":"Dirección de recepción...",
     "qsrjsdz":"Introduzca la dirección de recepción",
     "sjdz":"Llegada real: ",
     "sxf":"Tarifa: ",
     "txsm1":"Los retiros requieren una tarifa del 5%, que debe ser confirmada por el nodo de la red antes de que se pueda acreditar.",
     "txsm2":"Por favor no transfiera criptomonedas a extraños",
     "tz":"Notificar",
     "wdyq":"Mi invitación",
     "yhid":"UID",
     "hdjl":"Obtenga recompensas en USD",
     "yqsm":"Invita a tus amigos a participar en la cuantificación de IA, alquilar máquinas de minería e intercambiar productos para obtener recompensas en criptomonedas.",
     "yqsy":"Ingresos por invitación",
     "yqrs":"Número de personas invitadas",
     "tgljyq":"Invitar a través de enlace",
     "lj":"Enlace",
     "yqm":"Código de invitación",
     "cbtb":"Depositar y retirar",
     "jymx":"Detalles de la transacción",
     "yqhyjl":"Recompensas por invitar amigos",
     "aidd":"Órdenes comerciales doradas de IA",
     "jdls":"Historial de préstamos",
     "etfdd":"Órdenes ETF",
     "jmhbdd":"Órdenes de criptomonedas",
     "whdd":"Órdenes de divisas",
     "gpdd":"Órdenes de stock",
     "qx":"Cancelar",
     "zc":"Activos",
     "zzc":"Los activos totales",
     "ky":"Disponible",
     "zh2":"Convertido (USDT)",
     "xzbz":"Seleccionar: ",
     "sztkts":"Importante: vaya al Centro de seguridad para establecer una contraseña de transacción",
     "jymm":"Clave de transacción",
     "szjymm":"Establecer contraseña de transacción",
     "qsrjymm":"Clave de transacción",
     "zdsl":"Cantidad mínima.",
     "bq":"Etiqueta (nota)",
     "qsrbq":"Introducir etiqueta",
     "yhktx":"transferencia bancaria",
     "yhmc":"Nombre del banco",
     "qsryhmc":"Introduzca el nombre del banco",
     "yhzh":"Cuenta bancaria",
     "qsryhzh":"Ingrese el número de cuenta bancaria",
     "gjhkdm":"Código SWIFT",
     "qsrgjhkdm":"Introduce el código SWIFT",
     "yhdz":"Dirección del banco",
     "qsryhdz":"Introduzca la dirección del banco",
     "skrxm":"Nombre del beneficiario",
     "qsrskrxm":"Introduzca el nombre del beneficiario",
     "skrdh":"Número de teléfono del beneficiario",
     "qsrskrdh":"Ingrese el número de teléfono del beneficiario",
     "skrdz":"Dirección del beneficiario",
     "qsrskrdz":"Introduzca la dirección del beneficiario",
     "tbjl":"registro de retiro",
     "fzcg":"Copiado exitosamente",
     "aqzx":"Centro de Seguridad",
     "yxrz":"Verificacion de Email",
     "ybd":"Atado",
     "wbd":"No unido",
     "yrz":"Verificado",
     "wrz":"No certificado",
     "ts":"Para proteger su cuenta, se recomienda vincular su dirección de correo electrónico",
     "qsryxdz":"Ingrese correo electrónico",
     "dlmm":"Contraseña de inicio de sesión",
     "mbwtsz":"Configuración de problemas de seguridad",
     "mbwt":"Problema de seguridad",
     "qtxda":"Por favor complete la respuesta",
     "zyts":"Importante: ",
     "zytsCont":"No revele la respuesta de seguridad ni el código de verificación, y recuerde la pregunta de seguridad, que le ayudará a recuperar su contraseña.",
     "qsrxmm":"Introduzca una nueva contraseña",
     "sydqmmcz":"Restablecer con contraseña actual",
     "zhmm":"Problema de seguridad para recuperar la contraseña",
     "ysz":"Ha sido establecido",
     "tg":"ignorar",
     "qsrdlmm":"Ingresa tu contraseña",
     "bzxz":"Seleccionar: ",
     "zwsj":"Sin datos",
     "qd":"DE ACUERDO",
     "zsgd":"Mostrar más",
     "zdss":"Tamaño mínimo del lote",
     "mnjy":"Comercio simulado",
     "sx":"Selección",
   },
   "zb":{
     "tgdd":"Órdenes gestionadas por IA",
     "tgz":"En custodia",
     "ysh":"Redimido",
     "shz":"Redentor",
     "zq":"Ciclo: ",
     "tian":"Día",
     "syl2":"Tasa de retorno: ",
     "rgjg":"Precio de suscripción: ",
     "rgjg2":"Precio de suscripción",
     "xdsj":"Tiempo de la orden: ",
     "yhl":"Beneficiado: ",
     "syts":"El número restante de días: ",
     "sh":"Redención",
     "syl":"Tasa de retorno",
     "bz":"Nombre",
     "dl":"Tipo de cambio",
     "tgts":"Días de hospedaje: ",
     "tgsl":"Cantidad de alojamiento",
     "qsrtgsl":"Ingrese la cantidad de alojamiento",
     "dbxe":"Límite de transacción única",
     "ljtg":"Anfitrión ahora",
     "zztg":"Fondos en custodia",
     "yjjrsy":"Ganancias estimadas hoy",
     "ljsy":"Ingresos acumulados",
     "tgzdd":"Orden de custodia",
     "ljzc":"Transferir ahora",
     "gz":"Regla",
     "cpzq":"Ciclo del producto",
     "gm":"Comprar",
     "ts":"Importante",
     "shts":"Estás en el proceso de operación de canje y perderás el 5% si canjeas antes del vencimiento. ¿Estás seguro de canjear?",
     "xgcs":"Número de restricciones de compra",
   },
   "dk":{
     "dk":"Préstamo",
     "dkzh":"cuenta de préstamo",
     "yzsf":"¡Verifique su identidad y obtenga más montos de préstamos!",
     "ksyz":"Iniciar verificación",
     "wxj":"quiero pedir prestado...",
     "dkqx":"Plazo del préstamo (días): ",
     "mrll":"Tasa de interés diaria: ",
     "lxze":"Interés total: ",
     "dkts":"No se requieren intereses sobre el préstamo durante 3 días y los intereses se pueden pagar posteriormente",
     "xzj":"Préstamo ahora",
     "wyydbzx":"Aceptar",
     "dkfwxy":"<Acuerdo de servicio de préstamo>",
     "dkfwxy2":"Acuerdo de servicio de préstamo",
     "dkysxy":"Acuerdo de privacidad del préstamo",
     "dkjl":"Historial de préstamos",
     "hth":"No.",
     "yfk":"Desembolsado",
     "lx":"Interés: ",
     "zhke":"Importe total del reembolso: ",
     "znj":"Cargo del pago atrasado: ",
     "znjl":"Tasa de cargo por pago atrasado: ",
     "yqts":"Dias atrasados: ",
     "qhk":"Volver a pagar",
     "tpsc":"Préstamo de crédito (carga de imagen)",
     "fwxx":"Información de vivienda",
     "srzm":"Comprobante de ingresos (relación laboral)",
     "yhmx":"Detalles del banco",
     "zjz":"foto de identificación",
     "ljdk":"Préstamo ahora",
     "xm":"Nombre",
     "ndxm":"Su nombre",
     "qsrndxm":"Introduzca su nombre",
     "gj":"País",
     "ndgj":"Tu país",
     "qsrndgj":"Introduce tu país",
     "dz":"DIRECCIÓN",
     "nddz":"Su dirección",
     "qsrnddz":"Introduce tu dirección",
     "csrq":"Fecha de nacimiento",
     "ndcsrq":"Tu fecha de nacimiento",
     "qsrndcsrq":"Introduzca su fecha de nacimiento",
     "dhhm":"Número de teléfono",
     "nddhhm":"Su número de teléfono",
     "qsrnddhhm":"Ingrese su número telefónico",
     "zj":"Documentos",
     "sfzm":"Identidad positiva",
     "qscsfzm":"Sube el lado positivo de tu identidad",
     "sffm":"Contrario de identidad",
     "qscsffm":"Sube el reverso de tu identidad",
     "ddqr":"Confirmación del pedido",
     "jk":"Préstamo: ",
     "dkqx2":"Plazo del préstamo: ",
     "qrxd":"Confirmar pedido",
     "yhkxq":"Detalles del reembolso vencido",
     "hkqr":"Confirmación de pago",
     "yhk":"Deuda de Reembolso: ",
     "jksj":"Tiempo de préstamo: ",
     "ljhk":"Paga inmediatamente",
   },
   "jy":{
     "rq":"fecha",
     "qqjy":"Registro de opciones",
     "hyjy":"Contrato",
     "qqhy":"Opciones",
     "dqwt":"Pendiente",
     'wtz':"En Comisión",
     "hyjl":"Registro de contrato",
     "shou":"Lotes",
     "dk":"Oh: ",
     "zhjg":"El último: ",
     "jyfy":"Tarifa de transacción: ",
     "kfsj":"Horario de apertura: ",
     "gg":"Palanca: ",
     "pl":"Lote: ",
     "kpj":"Precio de apertura: ",
     "yk":"Ganancia y perdida: ",
     "cd":"Cancelar orden",
     "jsj":"Precio acordado: ",
     "fx":"Dirección: ",
     "jgsj":"El tiempo de entrega: ",
     "gb":"Cerca",
     "jxxd":"Continuar",
     "xj":"Límite: ",
     "gm":"Comprar: ",
     "sl":"Cantidad",
     "fy":"Costo: ",
     "tzbzj":"Ajustar margen",
     "zyzs":"Obtenga ganancias y detenga las pérdidas",
     "pc":"Posición cercana",
     "mr":"Comprar",
     "zjbzj":"Aumentar margen",
     "jsbzj":"Reducir margen",
     "yxhy":"comercio por contrato: ",
     "cc":"Puesto(s): ",
     "cc2":"Posición",
     "cwbzk":"Margen de posición: ",
     "zdzjbzj":"Incremento máximo de margen: ",
     "zjbzj2":"Aumentar margen: ",
     "qsrzbzj":"Por favor ingrese el depósito",
     "yxhy2":"Perpetuo",
     "kp":"puede ser plano",
     "zhang":"Abierto",
     "xj2":"Límite",
     "zy":"Saca provecho",
     "zs":"Detener la pérdida de",
     "ssjyzl":"Buscar tipo de transacción",
     "ddb":"Libro de pedidos",
     "di":"L: ",
     "gao":"h: ",
     "gb2":"C: ",
     "fz":"Minuto",
     "mai":"Compra: ",
     "zhang2":"Elevar",
     "tie":"Caer",
     "sy":"Devolver",
     "kz":"Alcista",
     "kt":"Osuno",
     "bndy":"No puede ser inferior a",
     "sxbzj":"Depósito de seguridad requerido: ",
     "ky":"Disponible: ",
     "sj":"Mercado",
     "mc":"Vender",
     "zxtzsl":"Cantidad mínima",
     "min":"Monto minimo",
     "max":"mayor cantidad",
     "yebz":"Saldo insuficiente",
     "ddz":"Espera",
     "wtzl":"Monto de comisiones: ",
     "wtjg":"Precio de comisión: ",
     "ycd":"Cancelado",
     "lswt":"Histórico",
     "qsrzyjg":"Por favor ingrese el precio de toma de ganancias",
     "qsrzsjg":"Por favor introduzca el precio del stop loss",
     "ccsl":"Número de posiciones: ",
     "ccjg":"Precio de posición: ",
     "ggbs":"Aprovecha múltiples: ",
     "zy2":"Saca provecho: ",
     "zs2":"Detener la pérdida de: ",
     "zje":"Suma global: ",
     "ss":"Lotes: ",
     "kcjg":"Precio de apertura: ",
     "bzjl":"Tasa de margen: ",
     "lscc":"Posiciones históricas",
     "gmj":"Precio de compra: ",
     "guadan":"Orden pendiente",
     "dqjg":"Precio actual: ",
     "gdjg":"Precio de pedido pendiente: ",
     "pcjg":"Precio de cierre: ",
     "ccsj":"Tiempo de mantenimiento de la posición: ",
     "gdsj":"Tiempo de espera del pedido: ",
     "pcsj":"Hora de cierre: ",
     "fdjyk":"Ganancias y pérdidas netas flotantes",
     "pcsl":"Cantidad de cierre",
     "qrpc":"Confirmar cierre de posición",
     "ypc":"Posición cerrada",
     "ss2":"Lotes",
     "qsrss":"Ingrese el tamaño del lote",
   },
   "gjrz":{
     "sfyz":"Certificación KYC",
     "t1":"1. Admite imágenes en formato JPG, JPEG o PNG de menos de 8 M.",
     "t2":"2. La foto del DNI debe ser clara y no se permite modificación ni bloqueo. El retrato, el número de identificación y el nombre deben estar claramente visibles.",
     "t3":"3. La foto debe tomarse sin sombrero y se recomienda no usar maquillaje. Los rasgos faciales de la persona que porta el documento deben ser claramente visibles y todo el brazo debe quedar expuesto.",
     "t4":"DE ACUERDO",
     "bh":"Rechazar",
     "shz":"Bajo revisión",
     "shtg":"Examen aprobado",
     "nyrzcg":"Has sido autenticado exitosamente",
     "sczjz":"Subir foto de identificación",
     "sczjzmz":"Sube una foto de frente de tu documento de identidad",
     "sczjbmz":"Sube la foto del reverso de tu DNI",
     "scgrqmz":"Sube una foto de tu DNI en mano",
     "gjlb":"Lista de países",
     "qxzgjlb":"Seleccione un país/región",
     "zsxm":"nombre real",
     "qsrzsxm":"Introduce tu nombre real",
     "zjlx":"Tipo de certificado: ",
     "zjhm":"número de identificación",
     "qsrzjhm":"Introduce tu número de DNI",
     "khh":"banco de apertura de cuenta",
     "qsrkhh":"Ingrese al banco de apertura de cuenta",
     "yhkh":"número de tarjeta bancaria",
     "qsryhkh":"Introduzca el número de tarjeta bancaria",
   },
   "status":{
     "statusText":['Error','En revisión','Éxito'],
   },
   "download":{
     "t1":"Comercio móvil, en cualquier momento y en cualquier lugar",
     "xz":"Descargar",
   },
   "langNew":{
     "jmm": "Contraseña anterior",
     "qsrjmm": "Ingrese su contraseña anterior.",
     "szhb": "Criptomoneda",
     "gjs": "Metal",
     "ny": "Energía",
     "yy": "Crudo",
     "jy": "Comercio",
     "jmhb": "Criptomoneda",
     "yxhy": "Contrato perpetuo",
     "gdjy": "orden pendiente",
     "khh": "Abrir cuenta bancaria",
     "qsrkhh": "Por favor ingrese al banco",
     "yhkh": "Cuenta bancaria",
     "qsryhkh": "Por favor, introduzca el número de cuenta bancaria",
     "mnzh":"cuenta demo",
     "zjjypt":"La mejor plataforma comercial",
     "brjmzndxq":"Este software satisface todas sus necesidades con la mejor experiencia técnica.",
     "jx":"Continuar",
     "yssm":"Declaracion de privacidad",
     "fxqzc":"Política contra el lavado de dinero",
     "jgxkz":"Licencia regulatoria",
     "ckgd":"Más",
     "gd":"Más",
     "dd":"Orden",
     "ckdd":"Ver pedidos",
     "yxdd":"Perpetuo",
     "qqdd":"Opciones",
     "hand":"Muchos= ",
     "lxwm":"Contáctenos",
     "tpfzl":"Coloque su imagen aquí, o ",
     "liulang":"navegar",
     "zctpgs":"Soporte: JPG, JPEG2000, PNG",
     "ysr":"Ingreso mensual",
     "ndysr":"Tus ingresos mensuales",
     "qsrndysr":"Introduce tus ingresos mensuales",
     "yqtzje":"Monto de inversión esperado",
     "qsrtzje":"Ingrese el monto de inversión esperado",
     "zszh":"Cuenta real",
     "qdl": "Por favor, registrese",
     "zx": "Favoritos",
     "hkdz":"Dirección de pago",
     "dkje":"Monto del préstamo: ",
     "zlx":"Interés total: ",
     "hkze":"Reembolso total: ",
     "qcz":"ir a depositar",
     "yebz":"Tu saldo es insuficiente, por favor recarga",
     "dhje":"Monto a reembolsar：",
     "hkjl":"orden de pago：",
     "hkje":"Balance：",
     "kyye":"Reembolso：",
     "qb": 'Todo',
     "lmc": "Nombre de la cadena：",
     "search": "Buscar",
     "mrjg":"Precio",
     "lxkf":"Contacto",
     "wyj":"daños y perjuicios",
     "yxsj":"Correr：",
     "jssj":"Finalizar：",
     "hksj":"Finalizar：",
     "sysj":"Tiempo restante：",
     "jkqx":"Plazo del préstamo：",
     "yq":"Atrasado：",
     "qqss":"Su orden de negociación de opciones ha expirado y su pérdida es",
     "qqlr":"Su orden de negociación de opciones ha caducado y su beneficio es",
     "bz":"Divisa",
     "dzje":"Cantidad recibida",
     "lxyxzc":"Soporte por correo electrónico",
   },
   "langNew9":{
   "dzje": "Tendencias del mercado de productos comerciales",
   "lxyxzc": "Comienza tu viaje de trading digital",
   "text1": "Comienza creando una cuenta",
   "text2": "Invita a tus amigos a unirse a MFTG para jugar juntos",
   "text3": "Recarga tu cuenta",
   "text4": "Admite recargas de múltiples divisas, lo que te permite comenzar a operar rápidamente",
   "text5": "Comienza a operar",
   "text6": "Ofrece una variedad de pares comerciales de alta calidad para elegir y comercia felizmente en MFTG",
  "text7": "Invita a tus amigos para ganar USDT",
  "text8": "Invita a tus amigos para ganar USDT fácilmente",
  "text9": "La función de préstamo está en línea",
  "text10": "Cuando no tienes dinero, puedes solicitar un préstamo, que se emitirá el mismo día como muy pronto",
   "text11": "Opere con todos los activos",
   "text12": "Forex, criptomonedas, futuros, ETF, etc.",
   },
   "bank":{
     "text1":"Tu plataforma de gestión financiera más confiable",
     "text2":"Alertas de noticias en tiempo real",
     "text3":"Comprender información en tiempo real sobre la industria financiera.",
     "text4":"empezar a entender",
     "text5":"noticia de última hora",
     "text6":"Elige banco",
     "text7":"tarjeta bancaria",
     "text8":"Cantidad...",
     "text9":"Añadir tarjeta bancaria",
     "text10":"cuenta bancaria",
     "text11":"Por favor ingrese la cuenta bancaria",
     "text12":"Identificación de tarjeta",
     "text13":"Por favor ingrese el número de tarjeta ID",
     "text14":"código internacional bancario",
     "text15":"código internacional bancario",
     "text16":"Por favor ingrese el número de teléfono",
     "text17":"añadir",
     "text18": "Eliminar tarjeta bancaria",
     "text19": "Llegada real",
     "text20": "Información de retiro",
     "text21": "Seleccionar tarjeta bancaria",
     "text22": "Notas",
     "text23": "Monto mínimo de retiro:",
     "text24": "No se permite el retiro si el monto es menor que el monto mínimo de retiro",
     "text25": "Para garantizar la seguridad de los fondos, cuando cambie la política de seguridad de su cuenta o cambie su contraseña, revisaremos manualmente el retiro. Espere pacientemente a que el personal se comunique con usted por teléfono o correo electrónico",
     "text26": "Asegúrese de que su computadora y su navegador sean seguros para evitar que la información sea alterada o filtrada",
     "text27": "Para los USD que retire, cada operación significa que la cantidad total de activos que se muestran en la página de retiro que posee se reducirá por el monto de retiro correspondiente",
     "text28": "Registro de retiro",
     "text29":"Tipo de moneda fiduciaria",
   },
   "team":{
     "tdjs":"Introducción del equipo",
     "wmdtd":"Nuestro equipo",
     "tdjj":"Brindamos a los operadores costos de transacción más bajos, mejor ejecución de órdenes y servicios financieros más seguros. Únase a un corredor comercial de clase mundial, que le permitirá participar fácilmente en el mercado financiero global.",
     "gltdjs":"Introducción al equipo directivo",
     "mc0":"Cristiano James Oram",
     "mc1":"Ari Cohen",
     "mc2":"David Charles Harrison",
     "mc3":"David Harding",
     "mc4":"Markus Johann Fischer",
     "mc5":"Michael Levine",
     "mc6":"Robin Matthes",
     "mc7":"Satya Raito",
     "zc0":"Director ejecutivo(CEO)",
     "zc1":"director de tecnología",
     "zc2":"Director financiero(CFO)",
     "zc3":"Asesor legal",
     "zc4":"Director de Operaciones(COO)",
     "zc5":"Director de Inversiones(CIO)",
     "zc6":"Director de crédito",
     "zc7":"Director de Datos e Inteligencia Artificial",
     "text01":"Seguridad y transparencia",
     "text02":"Siempre prestamos atención a la seguridad de los activos de los usuarios.",
     "text03":"Licencia regulatoria multinacional",
     "text04":"Acuerdo de protección de activos",
     "text05":"Auditoría independiente tripartita",
     "text06":"Las mejores condiciones comerciales",
     "text07":"Experiencia comercial definitiva",
     "text08":"Soporte para múltiples herramientas comerciales",
     "text09":"Ejecución eficiente de órdenes",
     "text10":"Datos profesionales de la línea K",
     "text11":"¿Listo para comenzar tu carrera con nosotros?",
     "ljks":"Empezar ahora",
     "技术副总裁":"Vicepresidente de Tecnología",
     "公共关系与对外事务总监":"Director de Relaciones Públicas y Asuntos Externos",
     "首席战略官":"Director de Estrategia",
     "首席人工智能科学家":"Científico Jefe de Inteligencia Artificial",
     "首席风险官":"Director de Riesgos"
   },
   "aiDetail":{
     "syxq":"Detalles de ingresos",
     "zsy":"ingresos totales",
     "rq":"fecha",
   }
   // "langNew2":{
   //   "sy":"Pagina de inicio",
   //   "sc":"Mercado",
   //   "sclb":"Lista de mercado",
   //   "jy":"Comercio",
   //   "zh":"Cuenta",
   //   "db":"Préstamos",
   //   "zchm":"Número de registro",
   //   "cp":"Producto",
   //   "tzjd":"Préstamos de inversión",
   //   "zxzc":"Soporte en línea",
   //   "xd":"Orden",
   //   "zzjptgmnr":"Invierta en su futuro. Haga crecer su cartera en un sistema financiero justo y abierto.",
   //   "yy":"Aplicación",
   //   "pqnr":"Banca móvil que rompe con las reglas tradicionales y te proporciona herramientas precisas de gestión financiera.",
   //   "jiami":"Cripto",
   //   "tgnr":"Al realizar depósitos utilizando criptomonedas, obtienes una capa adicional de seguridad y garantizas un procesamiento rápido de las transacciones.",
   //   "jyl":"Volumen de operaciones las 24 horas",
   //   "ssjmhb":"Listado de criptomonedas",
   //   "zchy":"Usuarios Registrados",
   //   "djxz":"Haga clic para descargar",
   //   "azsc":"Mercado de Android",
   //   "pgsd":"Tienda Apple",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/es.js